export default __webpack_public_path__ + "static/media/tiktok.4253b6fb.svg";